import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { HorizontalMenuItem, MenuItem } from '../../../interfaces/menu.interface';

import { CommonModule } from '@angular/common';
import { SectionsService } from '../../../services/sections.service';
import { BaseComponent } from '../../../shared/utils/base.component';
import { ListService } from '../../../shared/services/list.service';
import { NgZorroModule } from '../../../shared/modules/ng-zorro/ng-zorro.module';
import { MEMBER_VIEW_PAGE_IDS } from '../../../shared/constants/page.constants';
import { AuthorizeDirective } from '../../../shared/authorization/authorize.directive.';
import { environment } from '../../../../environments/environment';
import { UserService } from '../../../services/user.service';
import { AllowListAuthStore } from '../../../shared/authorization/allow-list-auth.store';
import { STATIC_JSON_DATA_PATH } from '../../../shared/constants/static-data.constants';
import { ButtonComponent } from '@ppl/ui';
import { LeadDetailSummaryComponent } from "../summary/lead-detail-summary/lead-detail-summary.component";
import { LeadInformationComponent } from "../participant-information/lead-information/lead-information.component";
import { FormChecklistComponent } from "../../leads/form-checklist/form-checklist.component";
import { AuthorizationComponent } from "../authorization/authorization.component";
import { AssociationsComponent } from "../associations/associations.component";
import { AdditionalAttributesComponent } from "../additional-attributes/additional-attributes.component";
import { ChecklistComponent } from "../check-list/ppl-checklist/checklist.component";
import { DocumentsComponent } from "../documents/documents/documents.component";
import { ToDoListComponent } from "../to-do-list/to-do-list/to-do-list.component";
import { TimesheetProviderListComponent } from "../../payroll/timesheets/timesheet-provider-list/timesheet-provider-list.component";
import { TimesheetConsumerListComponent } from "../../payroll/timesheets/timesheet-consumer-list/timesheet-consumer-list.component";
import { InvoiceConsumerListComponent } from "../../payroll/invoices/consumer/invoice-consumer-list/invoice-consumer-list.component";
import { ProviderInvoiceComponent } from "../../payroll/invoices/provider/provider-invoice/provider-invoice.component";
import { ConsumerRatesComponent } from "../consumer-rates/consumer-rates.component";
import { LeadDetailSignatureComponent } from "../lead-detail-signature/lead-detail-signature.component";
import { ParticipantSickTimeComponent } from "../participant-sick-time/participant-sick-time.component";
import { ProviderSickTimeComponent } from "../provider-sick-time/provider-sick-time.component";
import { PurchaseRequestParticipantViewComponent } from "../../payroll/purchase-request/purchase-request-participant-view/purchase-request-participant-view.component";
import { NzTabsModule } from 'ng-zorro-antd/tabs';

@Component({
  selector: 'ppl-member-wrapper-view',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NgZorroModule,
    AuthorizeDirective,
    ButtonComponent,
    LeadDetailSummaryComponent,
    LeadInformationComponent,
    FormChecklistComponent,
    AuthorizationComponent,
    AssociationsComponent,
    AdditionalAttributesComponent,
    ChecklistComponent,
    DocumentsComponent,
    ToDoListComponent,
    TimesheetProviderListComponent,
    TimesheetConsumerListComponent,
    InvoiceConsumerListComponent,
    ProviderInvoiceComponent,
    ConsumerRatesComponent,
    LeadDetailSignatureComponent,
    ParticipantSickTimeComponent,
    ProviderSickTimeComponent,
    PurchaseRequestParticipantViewComponent,
    NzTabsModule
],
  providers: [ListService],
  templateUrl: './member-wrapper-view.component.html',
  styleUrl: './member-wrapper-view.component.css',
})
export class MemberViewComponent extends BaseComponent implements OnInit, OnDestroy {
  // When true (pended-list quick view), the popup also renders Timesheet / Checklist /
  // Documents / To Do List in addition to the default lightweight tabs.
  @Input() showAllTabs = false;
  horizontalMenuItemstoDisplay: any;
  selectedMenuItem: any;
  enableComments = false;
  changedCLass = '';
  filledInfo: any;
  id: any;
  applicationData: any[] = [];
  listButton: any[] = [];

  applicationStatusList: any;
  entry: any;
  sectionDataPath: string = STATIC_JSON_DATA_PATH.LEAD_DETAILS_SECTION_DATA;
  program: any;
  pageId = '';
  tabId = '';
  steps: any;
  showSMSModal: any = '';
  notificationType = '';
  mobileNumber: string[] = [];
  emailId: string[] = [];
  isPageRestrictionLoaded = false;
  auditHistory: any;
  backLabel = "Back";
  leadData: any;
  isCommunicationLogs = false;
  isExternalEnvironment = false;

  constructor(
    private router: Router,
    private sectionsService: SectionsService,
    private userService: UserService,
    private allowListStore: AllowListAuthStore,
  ) {
    super();
  }
  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    this.isExternalEnvironment = environment.isExternal;
    this.program = this.userService.getSelectedProgram();
    this.entry = this.userService.getLeadEntry();
    this.id = JSON.parse(this.userService.getSelectedLead()!);
    this.pageId = MEMBER_VIEW_PAGE_IDS[this.userService.getFirstSegment()!];
    this.getMenuItems();
  }


  async getMenuItems() {
    try {
      if (this.entry) {
        const menu = await this.sectionsService.getJsonConfigurationData(
          STATIC_JSON_DATA_PATH.LEAD_DETAILS_MENU,
          this.entry
        );
        this.horizontalMenuItemstoDisplay = this.filterHorizontalMenuItems(
          menu.horizontal_menu
        );

        const navigateToTab = history?.state?.['navigateToTab'];
        const foundTab = this.horizontalMenuItemstoDisplay.find((menuItem: MenuItem) => {
          return menuItem?.menu_id?.toLowerCase() === (navigateToTab?.toLowerCase() || this.horizontalMenuItemstoDisplay[0]?.menu_id?.toLowerCase());
        });

        this.selectedMenuItem = foundTab?.menu_id?.toLocaleLowerCase();
      }
    } catch (e) {
      console.log('error fetching menu items: ', e);
    }
  }

  /**
   * All tabs this wrapper can render inline — mirrors the routed member-details view for both
   * provider and participant. The menu config + auth still decide which of these actually show.
   */
  private readonly supportedTabList = [
    'summary', 'enrollmentinformation', 'todolist', 'authorizations', 'associations',
    'consumerrates', 'documents', 'signature', 'forms', 'checklist', 'timesheet',
    'invoice', 'sicktime', 'purchaserequests', 'additionalattributes',
  ];

  private getSupportedTabs(): Set<string> {
    return new Set(this.supportedTabList);
  }

  get isParticipant(): boolean {
    return this.entry === 'participantEnrollment';
  }

  filterHorizontalMenuItems = (menu: HorizontalMenuItem): MenuItem[] => {
    const supportedTabs = this.getSupportedTabs();
    return menu.filter((menuItem: MenuItem) => {
      if (menuItem.display !== 'y') return false;
      if (!supportedTabs.has(menuItem.menu_id.toLowerCase())) return false;
      return this.allowListStore.isTabAllowed(this.pageId, menuItem.menu_id);
    });
  };

  onMenuSelection = (menuSelected: any) => {
    this.selectedMenuItem = menuSelected.menu_id.toLocaleLowerCase();
  };

  /** Index of the active tab within the displayed menu — drives the nz-tabset selection. */
  get selectedTabIndex(): number {
    const index = (this.horizontalMenuItemstoDisplay ?? []).findIndex(
      (menuItem: MenuItem) => menuItem?.menu_id?.toLowerCase() === this.selectedMenuItem
    );
    return index < 0 ? 0 : index;
  }

  onTabIndexChange(index: number): void {
    const item = this.horizontalMenuItemstoDisplay?.[index];
    if (item) {
      this.onMenuSelection(item);
    }
  }
}
